import { useMemo } from "react";
import { CallItem } from "../types/grants";
import { normalizeRegion } from "../constants/regions";

/**
 * Extracts unique, normalized region slugs from call items.
 * Shared across GrantsCalls, GrantsCallsArchive, and CallsList.
 */
export function useUniqueRegions(
  calls: CallItem[],
  allCalls?: CallItem[]
): string[] {
  return useMemo(() => {
    const sourceData = allCalls || calls;
    const regionsSet = new Set<string>();
    sourceData.forEach((call) => {
      call.targetRegions?.forEach((region) =>
        regionsSet.add(normalizeRegion(region))
      );
    });
    return Array.from(regionsSet).sort();
  }, [allCalls, calls]);
}
